/**
 * Meta Pixel helpers.
 * - Base pixel + first PageView are installed in /app/frontend/public/index.html.
 * - autoConfig is disabled there so Meta does not auto-fire PageView on SPA route
 *   changes (React Router pushState) or other implicit auto-events.
 * - This module adds per-session idempotency so each business event fires exactly
 *   once per browser session, even with React StrictMode double-mount in dev.
 */

const SESSION_KEY = "cnx_pixel_fired_events";

function fbqSafe(...args) {
  if (typeof window === "undefined") return;
  if (typeof window.fbq === "function") {
    try {
      window.fbq(...args);
    } catch {
      /* noop */
    }
  }
}

function alreadyFired(eventName) {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    const set = raw ? new Set(JSON.parse(raw)) : new Set();
    return set.has(eventName);
  } catch {
    return false;
  }
}

function markFired(eventName) {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    if (!arr.includes(eventName)) arr.push(eventName);
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(arr));
  } catch {
    /* noop */
  }
}

function fireOnce(method, eventName, params) {
  if (alreadyFired(eventName)) return;
  fbqSafe(method, eventName, params || {});
  markFired(eventName);
}

export function trackStandardOnce(eventName, params) {
  fireOnce("track", eventName, params);
}

export function trackCustomOnce(eventName, params) {
  fireOnce("trackCustom", eventName, params);
}
